/* eslint-disable no-console */
/* eslint-disable no-alert */
/**
 * Componente creado para la hackaton de Global DPI Summit 2025
 * Luego de hacer la demo, desabilitarlo usando la constante ENABLE_OPENID4VP_VERIFICATION
 * El componente es simplemente para una demo, no debe estar activo en producción
 *
 * Se tuvo que ajustar el package react-scripts de 4.0.3 a 5.0.1 para funcionar
 * con la versión 0.14.0 del package @mosip/react-inji-verify-sdk
 */
import React from 'react';
import { axiosAuth } from 'utils/axiosBackend';
import { OpenID4VPVerification } from '@mosip/react-inji-verify-sdk';
import { useLocation } from 'react-router-dom';
import { AUTOGESTION_IDP } from 'constants/RouterConstants';

const ENABLE_OPENID4VP_VERIFICATION = true;

export const OpenID4Verification = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const useId4Verification =
    searchParams.get('useId4Verification') === 'True' &&
    ENABLE_OPENID4VP_VERIFICATION;

  const sendTransactionId = txnId => {
    console.log('VP submission received, txn ID:', txnId);
    axiosAuth({
      method: 'post',
      url: 'oidc/v1/inji-verify-callback/',
      data: { transactionId: txnId },
    })
      .then(resp => {
        console.log('Callback result', resp);
        window.location.href = AUTOGESTION_IDP;
      })
      .catch(err => {
        alert(err.response.data.error_description);
      });
  };

  return (
    useId4Verification && (
      <div className="openid4vp-verification-container">
        <OpenID4VPVerification
          protocol="openid4vp://"
          verifyServiceUrl="https://inji-verify.iugolabs.com/v1/verify"
          clientId={window.location.host.split(':')[0]}
          presentationDefinition={{
            id: 'custom-verification',
            purpose: 'We need to verify your identity',
            format: { ldp_vc: { proof_type: ['Ed25519Signature2020'] } },
            input_descriptors: [
              {
                id: 'id-card-check',
                constraints: {
                  fields: [
                    {
                      path: ['$.type'],
                      filter: {
                        type: 'object',
                        pattern: 'CedulaUruguayaCredential',
                      },
                    },
                  ],
                },
              },
            ],
          }}
          onVPReceived={txnId => sendTransactionId(txnId)}
          onQrCodeExpired={() => alert('QR code expired, please try again')}
          onError={error => console.error('Error:', error)}
          triggerElement={
            <button type="button">📱 Verify with Digital Wallet</button>
          }
        />
      </div>
    )
  );
};
